import React, { createContext, useContext, useState } from 'react';

interface ProcessBulletinContextType {
  isProcessBulletinOpen: boolean;
  setIsProcessBulletinOpen: (open: boolean) => void;
  selectedCollectionId: string;
  setSelectedCollectionId: (id: string) => void;
  selectedProgramId: string;
  setSelectedProgramId: (id: string) => void;
}

const ProcessBulletinContext = createContext<ProcessBulletinContextType | undefined>(undefined);

export const ProcessBulletinProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isProcessBulletinOpen, setIsProcessBulletinOpen] = useState(false);
  const [selectedCollectionId, setSelectedCollectionId] = useState("");
  const [selectedProgramId, setSelectedProgramId] = useState("");

  return (
    <ProcessBulletinContext.Provider 
      value={{ 
        isProcessBulletinOpen, 
        setIsProcessBulletinOpen,
        selectedCollectionId,
        setSelectedCollectionId,
        selectedProgramId,
        setSelectedProgramId
      }}
    >
      {children}
    </ProcessBulletinContext.Provider>
  );
};

export const useProcessBulletin = () => {
  const context = useContext(ProcessBulletinContext);
  if (context === undefined) {
    throw new Error('useProcessBulletin must be used within a ProcessBulletinProvider');
  }
  return context;
};
